// Italian — scripts/translate-locale.mjs 로 생성 (en.js 기준).
// 손으로 고친 값은 다음 실행에서 덮이지 않는다 (--force 제외).
// 자리표시자({n} 등)가 어긋난 항목은 영어를 그대로 둔다.
export const it = {
  "uploadTitle": "Carica foto",
  "uploadHint": "Clicca o trascina le immagini qui",
  "uploadHintTouch": "Tocca per scegliere le foto",
  "uploadOr": "o",
  "takePhoto": "Scatta foto",
  "yourPhotos": "Le tue foto",
  "photoLabel": "Foto {n}",
  "photoCount": "{n} foto",
  "addPhoto": "Aggiungi foto",
  "continue": "Continua",
  "stepLabel": "Passo {current} di {total}",
  "chooseStyle": "Scegli uno stile di design",
  "describeCustomStyle": "Descrivi il tuo stile personalizzato",
  "uploadReferenceTitle": "Carica una foto di riferimento",
  "uploadReferenceHint": "L'IA abbinerà toni, materiali e atmosfera — la foto della tua stanza non cambierà.",
  "removeReference": "Rimuovi riferimento",
  "cleanupOptionTidy": "Riordina",
  "cleanupOptionTidyDesc": "Mantieni i mobili, rimuovi disordine, spazzatura e stoviglie",
  "cleanupOptionEmpty": "Svuota la stanza",
  "cleanupOptionEmptyDesc": "Rimuovi mobili e decorazioni. Pareti e pavimento rimangono",
  "cleanupChooseOption": "Scegli come fare pulizia",
  "layoutOptionFlow": "Flusso migliore",
  "layoutOptionFlowDesc": "Migliora i passaggi e l'accesso — più facile muoversi",
  "layoutOptionSpacious": "Più spaziosa",
  "layoutOptionSpaciousDesc": "Libera la vista e riduci il disordine visivo — sembra più grande",
  "planChooseOption": "Cosa vuoi creare dalla tua planimetria?",
  "planOption_3d": "Planimetria 3D",
  "planOption_3dDesc": "L'intera casa dall'alto, arredata nello stile scelto",
  "planOption_room": "Una stanza",
  "planOption_roomDesc": "Colora una stanza sulla pianta e vedila ad altezza occhi",
  "planOption_clean": "Ridisegna la planimetria",
  "planOption_cleanDesc": "Uno schizzo o una planimetria sfocata, ridisegnata con cura",
  "planCleanKindTitle": "Tipo di disegno",
  "planCleanKind_line": "Bianco e nero",
  "planCleanKind_color": "Planimetria a colori",
  "planStyleTitle": "Stile",
  "planRoomTitle": "Quale stanza?",
  "planRoomSignIn": "Accedi per scegliere una stanza sulla pianta.",
  "planRoomPaint": "Colora la stanza sulla pianta",
  "planRoomPicked": "Stanza selezionata",
  "planRoomRepaint": "Ricolora",
  "planRoomClear": "Cancella",
  "planRoomNamePlaceholder": "O scrivi il nome della stanza (es. camera matrimoniale)",
  "planCropHint": "Ritaglia la foto sulla planimetria per un risultato più preciso.",
  "planFirstOnly": "Solo la prima foto verrà usata come planimetria.",
  "planRoomPickTitle": "Scegli una stanza",
  "planRoomPickHint": "Colora la stanza che vuoi vedere. Basta un tratto approssimativo.",
  "planRoomPickDone": "Usa questa stanza",
  "planRoomNeedPick": "Colora una stanza sulla pianta o scrivine il nome.",
  "errNotFloorplan": "Non sembra una planimetria. Carica una planimetria o scegli uno stile.",
  "planRoomFrom": "Stanza scelta sulla pianta",
  "planInputLabel": "Planimetria",
  "planOutput_plan_3d": "Planimetria 3D",
  "planOutput_plan_room": "Vista stanza",
  "planOutput_plan_clean": "Planimetria ridisegnata",
  "planOutput_plan_color": "Planimetria a colori",
  "planRoomFromResult": "Vedi una stanza",
  "planRoomMake": "Crea questa stanza",
  "planRoomMeta": "{n} crediti · questa stanza ad altezza occhi, stessa casa",
  "layoutChooseOption": "Scegli come disporre",
  "creditEarnHint": "Guadagna crediti con l'accesso giornaliero (+1) o invitando amici (+5 ciascuno).",
  "languageHint": "Usato anche per l'analisi del design.",
  "reuseStyle": "— Riusa uno stile passato —",
  "customPlaceholder": "Descrivi lo stile che desideri (es. 'baita accogliente con toni caldi del legno', 'minimalista futuristico con dettagli metallici')",
  "customStylePublicHint": "Il testo dello stile personalizzato può apparire in modo anonimo nella community. Puoi disattivarlo nelle impostazioni dell'account.",
  "communityRankTitle": "Stili di tendenza",
  "communityPeople": "Usato da {n} persone",
  "customStylesChip": "Stili personalizzati",
  "galleryRecentBadge": "Appena usato",
  "timeJustNow": "ora",
  "timeAgoMin": "{n} min fa",
  "timeAgoHour": "{n} h fa",
  "communityViewAll": "Vedi tutti",
  "galleryTitle": "Stili di tendenza",
  "briefsLabel": "Novità",
  "briefTopupKicker": "Crediti",
  "briefTopupTitle": "Crediti insufficienti per il prossimo progetto",
  "briefTopupLine": "I crediti gratis si ricaricano domani. Ne vuoi altri ora? Prendi un pacchetto.",
  "briefSeasonKicker": "Di stagione",
  "briefSeasonTitle": "{name} è qui",
  "briefSeasonLine": "Uno stile stagionale — solo per poche settimane.",
  "briefInviteKicker": "Invita",
  "briefInviteTitle": "Invita un amico — +{n} crediti per entrambi",
  "briefInviteLine": "Condividi il tuo link. I crediti arrivano alla loro iscrizione.",
  "galleryEmpty": "Niente di tendenza qui per ora — gli stili appariranno quando le persone inizieranno a usarli.",
  "galleryBuiltinTitle": "Classifica stili del momento",
  "galleryPopularCustom": "Stili personalizzati del momento",
  "galleryDiscoverTitle": "Scopri stili personalizzati",
  "galleryShuffle": "Mescola",
  "galleryTranslate": "Traduci",
  "galleryTranslating": "Traduzione in corso…",
  "galleryOriginal": "Mostra originale",
  "galleryLiveTab": "Live",
  "galleryLiveWaiting": "In attesa di nuovi stili…",
  "galleryLiveTitle": "In uso in questo momento",
  "galleryRecentCustom": "Stili personalizzati recenti",
  "galleryUse": "Usa questo stile",
  "styleShareNotice": "Il testo dello stile personalizzato può apparire in modo anonimo nella community.",
  "styleShareNoticeSettings": "Disattiva nelle impostazioni",
  "styleShareNoticeOk": "Capito",
  "communityTopTitle": "Stili personalizzati popolari",
  "communityRecentTitle": "Appena usati da altri",
  "communityUses": "Usato {n}×",
  "communityDesigns": "{n} design",
  "communityDesignsOne": "{n} design",
  "styleShareTitle": "Condividi stili personalizzati",
  "styleShareDesc": "Fai scoprire e provare ad altri lo stile personalizzato che hai scritto. Le tue foto non saranno mai condivise.",
  "additionalRequests": "Richieste aggiuntive",
  "optional": "(opzionale)",
  "additionalPlaceholder": "Qualche aggiunta specifica per il tuo design {style}? (es. 'aggiungi un tavolino in legno', 'usa il verde ottanio come colore d'accento')",
  "addAdditionalRequest": "+ Aggiungi richieste specifiche",
  "generateDesign": "Genera design",
  "back": "Indietro",
  "generatingOne": "L'IA sta generando il tuo design d'interni…",
  "generatingMany": "L'IA sta generando {n} design coerenti per la tua stanza…",
  "generatingOneExterior": "L'IA sta generando il tuo restyling esterno…",
  "generatingManyExterior": "L'IA sta generando {n} render esterni coerenti…",
  "generatingOneGarden": "L'IA sta generando il tuo restyling del giardino…",
  "generatingManyGarden": "L'IA sta generando {n} render del giardino coerenti…",
  "generationFailed": "Generazione non riuscita",
  "tryAgain": "Riprova",
  "errNoInternet": "Nessuna connessione internet. Controlla la rete e riprova.",
  "errTimeout": "L'IA ha impiegato troppo tempo a rispondere. Riprova.",
  "errTooMany": "Troppe richieste. Attendi un momento e riprova.",
  "errNetwork": "Errore di rete. Controlla la connessione e riprova.",
  "errAI": "Il servizio di design IA ha riscontrato un problema. Riprova.",
  "errFileType": "Formato file non supportato. Carica un'immagine JPEG, PNG o WebP.",
  "errFileTooLarge": "File troppo grande. Carica un'immagine inferiore a 20 MB.",
  "errPhotoRead": "Impossibile leggere la foto. Prova con un'altra.",
  "errCameraAccess": "Impossibile accedere alla fotocamera. Abilita l'accesso nelle Impostazioni.",
  "errCameraCapture": "Impossibile scattare la foto. Riprova.",
  "errCaptionSave": "Impossibile salvare la didascalia. Riprova.",
  "imageUnavailable": "Immagine non disponibile",
  "designShareText": "Dai un'occhiata a questo design {style} creato con archelier",
  "altPhoto": "Foto {n}",
  "altOriginal": "Originale {n}",
  "altGenerated": "Design {n}",
  "errInvalidSpace": "Impossibile riconoscere lo spazio. Usa una foto che mostri una stanza: parete e pavimento insieme, o un angolo della stanza.",
  "pickAnotherPhoto": "Scegli un'altra foto",
  "errCustomStyle": "Descrivi il tuo stile personalizzato.",
  "errSignIn": "Accesso non riuscito. Riprova.",
  "errInsufficientCredits": "Crediti esauriti. Torna domani per il tuo bonus giornaliero.",
  "creditCostHint": "{n} foto usano {c} crediti — {p} per foto.",
  "errCreditsShort": "Servono {need} crediti e ne hai {have}. Rimuovi una foto o invita un amico per averne altri.",
  "credits": "Crediti",
  "creditsOne": "{n} credito",
  "creditsMany": "{n} crediti",
  "outOfCredits": "Crediti esauriti",
  "creditModalTitle": "Ottieni altri crediti",
  "creditModalDesc": "I tuoi crediti giornalieri si ricaricheranno domani. Ne vuoi altri prima?",
  "creditModalWallDesc": "Hai finito i progetti gratuiti di oggi. Domani ne avrai altri {n} — oppure ricarica ora e continua.",
  "errOutOfCreditsToday": "Hai esaurito i crediti per oggi. Domani avrai altri {n} progetti gratuiti — o ricarica per continuare.",
  "lastFreeHint": "Questo era l'ultimo progetto gratuito di oggi. Domani ne avrai altri {n}.",
  "lastFreeHintCta": "Ricarica ora",
  "creditModalChatFree": "La chat con Gio, il tuo designer, resta gratuita.",
  "creditModalGuestTitle": "Accedi per continuare a creare",
  "creditModalGuestDesc": "Accedendo riceverai crediti gratuiti ogni giorno, oltre a poter salvare e condividere.",
  "creditOptionSignIn": "Accedi e continua",
  "creditOptionSignInDesc": "Inizia in un attimo con Google o Apple",
  "creditOptionInvite": "Invita un amico",
  "creditOptionInviteDesc": "Entrambi riceverete +{n} crediti alla loro iscrizione",
  "comingSoon": "Prossimamente",
  "close": "Chiudi",
  "getAppTitle": "archelier",
  "getAppDesc": "Ridisegna il tuo spazio nell’app",
  "getAppCta": "Ottieni",
  "appGateTitle": "Continua nell’app",
  "appGateDesc": "Progettare è più comodo nell’app: fotocamera, progetti salvati e risultati più veloci.",
  "appGateCta": "Scarica l’app",
  "appGateNotNow": "Non ora",
  "dailyBonusHint": "Ricevi {n} crediti gratuiti ogni giorno.",
  "creditsAria": "{n} crediti rimasti",
  "accountCreditsTitle": "Crediti",
  "creditsDailyLabel": "Giornalieri, si ricaricano a mezzanotte",
  "creditsBonusLabel": "Bonus, senza scadenza",
  "creditsResetHint": "Ricevi {n} crediti gratuiti ogni giorno. I crediti bonus degli inviti rimangono finché non li usi.",
  "creditsInviteCta": "Invita un amico per +{n}",
  "creditsTopUpCta": "Acquista crediti",
  "inviteMenu": "Invita amici",
  "profileShare": "Condividi",
  "profileShareText": "Dai un'occhiata ai design di {name} su archelier.",
  "original": "Originale",
  "aiDesign": "Design IA",
  "imageGenFailed": "Generazione dell'immagine non riuscita per questa foto",
  "seeAnalysis": "Vedi l'analisi del design qui sotto.",
  "analysisTitle": "Analisi del design d'interni",
  "spaceAnalysis": "Analisi dello spazio",
  "styleDescription": "Descrizione dello stile",
  "colorPalette": "Tavolozza colori",
  "furnitureRec": "Consigli sull'arredamento",
  "shopFor": "Acquista {item}",
  "shopShort": "Acquista",
  "paintMatch": "Colore pittura più simile",
  "paintCodeCopy": "Copia codice colore",
  "paintCodeCopied": "Codice copiato",
  "editRegion": "Modifica una parte",
  "editRegionTitle": "Modifica questo design",
  "editRegionDesc": "Dì all'IA cosa cambiare e cosa mettere al suo posto. Il resto della stanza non cambia.",
  "editRegionBrushHint": "Dì all'IA cosa cambiare o aggiungere. Per modificare un punto, evidenzialo prima con il pennello — altrimenti modificherà l'intera immagine. Per rimuovere qualcosa, evidenzialo e scrivi “rimuovilo”.",
  "editRegionMeta": "Salvato come nuovo design · {n} crediti",
  "editedFromBanner": "Questa è una copia modificata.",
  "viewOriginal": "Vedi originale",
  "editsOfThisDesign": "Modifiche di questo design",
  "editsOfThisDesignDesc": "Design che hai creato modificando parti di questo.",
  "chatTitle": "Consulente di design IA",
  "chatHint": "Fai domande su questa stanza. L'IA vede il tuo design e si basa su di esso.",
  "chatStart": "Inizia una conversazione",
  "chatPlaceholder": "Chiedi di un mobile, colore o disposizione…",
  "chatSend": "Invia",
  "chatSending": "Sto pensando…",
  "chatSuggestion1": "Quale lampada renderebbe la stanza più calda?",
  "chatSuggestion2": "Come posso far sembrare lo spazio più grande?",
  "chatSuggestion3": "Quali sono le prime 3 cose da cambiare?",
  "chatTurnsRemaining": "{n} messaggi rimasti per questo design",
  "chatTurnsExhausted": "Hai raggiunto il limite di messaggi per questo design. Creane uno nuovo per continuare.",
  "chatErrGeneric": "Il consulente non ha potuto rispondere. Riprova.",
  "chatPro": "Pro — chat illimitata",
  "chatRetry": "Riprova",
  "commentsTitle": "Commenti",
  "commentPlaceholder": "Aggiungi un commento",
  "commentPost": "Pubblica",
  "commentPosting": "Pubblicazione…",
  "commentSignInHint": "Accedi per lasciare un commento.",
  "commentEmpty": "Ancora nessun commento.",
  "commentDelete": "Elimina",
  "commentDeleteConfirm": "Eliminare questo commento?",
  "commentTooLong": "I commenti sono limitati a 500 caratteri.",
  "commentErrGeneric": "Impossibile pubblicare il commento. Riprova.",
  "commentCount": "{n}",
  "bookmarksTitle": "Le mie raccolte",
  "tabDesigns": "Design",
  "tabCollections": "Raccolte",
  "bookmarksSectionTitle": "Design salvati",
  "bookmarksEmpty": "Ancora nessuna raccolta. Salva un design per iniziare.",
  "bookmarksAdd": "Salva",
  "bookmarksAdded": "Salvato",
  "bookmarksRemove": "Rimuovi dai salvati",
  "bookmarksSignInHint": "Accedi per salvare i design.",
  "saved": "Salvato",
  "savedCollectionDefault": "Salvati",
  "follow": "Segui",
  "unfollow": "Non seguire più",
  "following": "Seguito",
  "followers": "Follower",
  "followingTab": "Seguiti",
  "followingEmpty": "Segui altre persone per vedere qui i loro ultimi design.",
  "followersEmpty": "Ancora nessun follower.",
  "followingEmpty2": "Non segui ancora nessuno.",
  "followSignInHint": "Accedi per seguire",
  "cannotFollowSelf": "Non puoi seguire te stesso.",
  "profile": "Profilo",
  "profileNotFound": "Questo profilo non esiste.",
  "profileDesigns": "Design",
  "profileDesignsCount": "Progetti",
  "profileFollowers": "Follower",
  "profileFollowing": "Seguiti",
  "profileBio": "Bio",
  "profileEdit": "Modifica profilo",
  "profileMyProfile": "Il mio profilo",
  "displayNameLabel": "Nome visualizzato",
  "displayNamePlaceholder": "Il tuo nome o studio (opzionale)",
  "displayNameSave": "Salva nome",
  "displayNameSaved": "Nome salvato",
  "displayNameErrGeneric": "Impossibile salvare il nome. Riprova.",
  "handleLabel": "Nome utente",
  "handlePlaceholder": "lettere minuscole, cifre, underscore (3-20 car.)",
  "handleSave": "Salva nome utente",
  "handleSaved": "Nome utente salvato",
  "handleInvalid": "Il nome utente deve contenere 3-20 caratteri: a-z, 0-9, underscore.",
  "handleTaken": "Questo nome utente è già occupato.",
  "handleErrGeneric": "Impossibile salvare il nome utente. Riprova.",
  "bioPlaceholder": "Racconta qualcosa di te (max 200 caratteri)",
  "bioSave": "Salva bio",
  "bioSaved": "Bio salvata",
  "bioErrGeneric": "Impossibile salvare la bio. Riprova.",
  "instagramLabel": "Instagram",
  "instagramPlaceholder": "tuo_nome_instagram",
  "instagramInvalid": "Usa solo lettere, cifre, punti o underscore (max 30).",
  "profileNoDesigns": "Ancora nessun progetto.",
  "collections": "Raccolte",
  "collectionsTab": "Raccolte",
  "collectionMine": "Le mie raccolte",
  "collectionEmpty": "Ancora nessuna raccolta.",
  "collectionPublicEmpty": "Nessuna raccolta pubblica.",
  "collectionItemCount": "{n} elementi",
  "collectionEmpty2": "Questa raccolta è vuota.",
  "newCollection": "Nuova raccolta",
  "collectionNamePlaceholder": "Nome raccolta (es. Idee soggiorno)",
  "collectionCreate": "Crea",
  "collectionDelete": "Elimina raccolta",
  "collectionDeleteConfirm": "Eliminare questa raccolta? Gli elementi verranno rimossi.",
  "collectionRename": "Rinomina raccolta",
  "collectionVisibility": "Raccolta pubblica",
  "collectionVisibilityOn": "Chiunque abbia il link può visualizzare",
  "collectionVisibilityOff": "Solo tu puoi vedere questa raccolta",
  "addToCollection": "Aggiungi alla raccolta",
  "saveToCollection": "Salva nella raccolta",
  "collectionAdded": "Aggiunto",
  "collectionRemoveFromBoard": "Rimuovi dalla raccolta",
  "collectionShareLink": "Copia link della raccolta",
  "collectionByOwner": "di",
  "collectionNotFound": "Questa raccolta non esiste o è privata.",
  "collectionErrCreate": "Impossibile creare la raccolta.",
  "collectionErrSave": "Impossibile aggiornare la raccolta.",
  "collectionDone": "Fatto",
  "collectionPickerHint": "Tocca una raccolta per aggiungere o rimuovere questo progetto.",
  "uploadAcceptsHint": "Le foto funzionano meglio, ma vanno bene anche schizzi, prospetti, planimetrie e screenshot 3D.",
  "examplePhotos": "Foto di esempio",
  "detectedInputTypes": {
    "sketch": "Schizzo",
    "elevation": "Prospetto",
    "floorplan": "Planimetria",
    "3d_model": "Modello 3D"
  },
  "floorplanDetectedBanner": "Sembra una planimetria: è stata renderizzata la stanza comune più grande ad altezza occhi. Per scegliere una stanza specifica, la prossima volta aggiungi una nota alla tua richiesta (es. \"renderizza la camera da letto principale\").",
  "floorplanDetectedBannerWithRoom": "Sembra una planimetria — abbiamo renderizzato il {room} ad altezza occhi. Per scegliere un'altra stanza, aggiungi una nota alla tua richiesta la prossima volta.",
  "spaceCategoryTitle": "Cosa stai progettando?",
  "spaceCategories": {
    "interior": "Interni",
    "exterior": "Esterni",
    "garden": "Giardino"
  },
  "exteriorStyles": {
    "halloween": {
      "name": "Halloween",
      "description": "Zucche, lanterne, portico autunnale"
    },
    "christmas": {
      "name": "Natale",
      "description": "Ghirlande, luci calde, festoni di abete"
    },
    "lunar_new_year": {
      "name": "Capodanno lunare",
      "description": "Lanterne rosse, oro, distici benaugurali"
    },
    "spring_blossom": {
      "name": "Fioritura di primavera",
      "description": "Alberi in fiore, aiuole pastello, luce fresca"
    },
    "modern_facade": {
      "name": "Facciata moderna",
      "description": "Geometrie pulite, grandi vetrate, materiali misti"
    },
    "modern_farmhouse": {
      "name": "Modern Farmhouse",
      "description": "Rivestimento bianco, finiture nere, dettagli in legno"
    },
    "mediterranean": {
      "name": "Mediterraneo",
      "description": "Intonaco, terracotta, aperture ad arco"
    },
    "craftsman": {
      "name": "Craftsman",
      "description": "Scandole in legno, tetti a falda bassa, travi a vista"
    },
    "contemporary": {
      "name": "Contemporaneo",
      "description": "Linee decise, volumi audaci, materiali industriali"
    },
    "minimalist_exterior": {
      "name": "Esterno minimalista",
      "description": "Palette sobria, focus su un unico materiale"
    },
    "tudor": {
      "name": "Tudor",
      "description": "Revival Tudor inglese — a graticcio con timpani ripidi"
    },
    "cape_cod": {
      "name": "Cape Cod",
      "description": "Tradizionale del New England — scandole bianche e persiane nere"
    },
    "japanese_traditional": {
      "name": "Tradizionale giapponese",
      "description": "Struttura in legno stile Minka con tetto in tegole ed engawa"
    },
    "mountain_cabin": {
      "name": "Baita di montagna",
      "description": "Baita in legno o con struttura ad A immersa nella natura"
    },
    "midcentury_exterior": {
      "name": "Esterno Mid-Century",
      "description": "Modernismo anni '50-'60 — tetto piano, grandi vetrate, linee orizzontali"
    }
  },
  "gardenStyles": {
    "halloween": {
      "name": "Halloween",
      "description": "Zucche, lanterne, giardino autunnale"
    },
    "christmas": {
      "name": "Natale",
      "description": "Sempreverdi illuminati, luci calde, giardino d’inverno"
    },
    "lunar_new_year": {
      "name": "Capodanno lunare",
      "description": "Lanterne rosse, rami fioriti, giardino benaugurale"
    },
    "spring_blossom": {
      "name": "Fioritura di primavera",
      "description": "Ciliegi, tulipani, verde primaverile"
    },
    "modern": {
      "name": "Giardino moderno",
      "description": "Geometrie definite, pavimentazione in cemento, graminacee ornamentali"
    },
    "mediterranean": {
      "name": "Mediterraneo",
      "description": "Ghiaia, ulivi e lavanda, vasi in terracotta, pergola"
    },
    "coastal": {
      "name": "Costiero",
      "description": "Graminacee, legni marini, piante resistenti alla salsedine"
    },
    "minimalist": {
      "name": "Minimalista",
      "description": "Singolo materiale, palette botanica essenziale, spazio vuoto"
    },
    "zen": {
      "name": "Giardino Zen",
      "description": "Ghiaia rastrellata, pietre, piante diradate"
    },
    "cottage": {
      "name": "Cottage Garden",
      "description": "Romantico, vegetazione fitta, piante perenni miste"
    },
    "desert": {
      "name": "Desertico / Xeriscape",
      "description": "Piante resistenti alla siccità, succulente, ghiaia"
    },
    "tropical": {
      "name": "Tropicale",
      "description": "Fogliame lussureggiante, grandi foglie, fioriture vivaci"
    },
    "english": {
      "name": "Giardino all'inglese",
      "description": "Prato curato, siepi, bordure fiorite a strati"
    }
  },
  "seasonLabel": "Stagione",
  "seasons": {
    "none": "Qualsiasi",
    "spring": "Primavera",
    "summer": "Estate",
    "autumn": "Autunno",
    "winter": "Inverno"
  },
  "timeOfDayLabel": "Ora del giorno",
  "timesOfDay": {
    "none": "Qualsiasi",
    "day": "Diurno",
    "golden_hour": "Golden hour",
    "night": "Notturno"
  },
  "editRegionReplacementLabel": "Cosa vuoi modificare?",
  "editRegionReplacementPlaceholder": "es. aggiungi una grande statua accanto all'ingresso",
  "editRegionSubmit": "Genera modifica",
  "editRegionGenerating": "Generazione dell'immagine modificata…",
  "editRegionMaskRequired": "Pennella prima l'area che vuoi modificare.",
  "editRegionReplacementRequired": "Dicci cosa inserire lì.",
  "editRegionBrush": "Pennello",
  "editRegionUndo": "Annulla",
  "editRegionSize": "Dimensione",
  "editRegionClear": "Azzera",
  "errEditGeneric": "Modifica non riuscita. Riprova.",
  "lightingPlan": "Piano luci",
  "designTips": "Consigli di design",
  "startNew": "Nuovo progetto",
  "viewMyDesigns": "I miei progetti",
  "favorite": "Preferito",
  "unfavorite": "Rimuovi dai preferiti",
  "rename": "Rinomina",
  "savePromptText": "Accedi per salvare questo progetto, condividerlo e crearne altri",
  "guestCreditsLeft": "Solo {n} progetto gratuito rimasto. Accedi e inizia con {total}.",
  "guestCreditsGone": "Questo era il tuo ultimo progetto gratuito. Accedi e ottieni {total}.",
  "signInGoogle": "Accedi con Google",
  "signInApple": "Accedi con Apple",
  "signInDesc": "Salva i tuoi progetti e accedi in qualsiasi momento.",
  "signInPopupBlocked": "Il popup è stato bloccato. Abilita i popup nelle impostazioni del browser.",
  "appName": "archelier",
  "navCreate": "Crea",
  "navGallery": "Galleria",
  "navGio": "Designer",
  "navMain": "Navigazione principale",
  "packsTitle": "Ricarica",
  "packDesigns": "circa {n} design",
  "packBuying": "Apertura…",
  "packWaiting": "Pagamento completato — aggiunta crediti…",
  "packDone": "Crediti aggiunti.",
  "packSlow": "I tuoi crediti stanno arrivando. Appariranno a breve — non serve acquistarli di nuovo.",
  "packFailed": "L'acquisto non è andato a buon fine. Se ti è stato addebitato ma non vedi i crediti, contatta il supporto.",
  "gioRole": "Space designer",
  "gioAiNote": "AI",
  "gioSignInBody": "Accedi per parlare con Gio. Gio guarda le foto della tua stanza e i tuoi design passati, ti suggerisce stili e può creare o modificare un design per te direttamente in chat.",
  "gioGreeting": "Ciao, sono Gio. Inviami una foto del tuo spazio, un'immagine o link di una stanza che ami, o un tuo design — ti suggerirò uno stile e lo creerò per te.",
  "gioChipTaste": "Qual è il mio stile?",
  "gioChipTrend": "Cosa va di moda questa settimana?",
  "gioChipPhoto": "Invia foto di una stanza",
  "gioChipMine": "Usa un mio design",
  "gioTyping": "Gio sta pensando…",
  "gioPlaceholder": "Chiedi a Gio o incolla un link",
  "gioSend": "Invia",
  "gioAttachPhoto": "Allega foto",
  "gioPickDesign": "I miei design",
  "gioPickEmpty": "Nessun design ancora — creane uno prima, poi portalo qui.",
  "gioRemove": "Rimuovi",
  "gioToday": "Oggi",
  "gioNoCredits": "Hai esaurito i crediti.",
  "gioError": "Gio non è riuscito a rispondere ora. Riprova tra poco.",
  "gioAlreadyStarting": "Sto già iniziando — un attimo di pazienza.",
  "gioPhotoSkipped": "Alcune foto non sono state aggiunte. Puoi allegare fino a {n} foto (JPG, PNG, WebP o HEIC, sotto i 20 MB).",
  "gioErrPhotos": "Non è stato possibile trovare le foto. Aggiungi una foto del tuo spazio e riprova.",
  "gioErrPrompt": "Gio non è riuscito a trasformarlo in un design. Prova a descriverlo in modo diverso.",
  "gioErrGone": "Quel design o suggerimento non è più disponibile.",
  "gioCreditsLow": "{n} crediti rimasti · un messaggio usa {c}, {p} con foto",
  "gioCreditsLowFree": "{n} crediti rimasti · chattare con Gio è gratis",
  "gioNoCreditsChatFree": "Hai finito i crediti per i progetti — chattare è ancora gratis.",
  "gioDailyLimit": "Abbiamo chattato tanto per oggi. Riprendiamo domani.",
  "gioCardEdit": "Modifica",
  "gioCardPhotos": "Foto pronte: {n}",
  "gioCardPhotoFromDesign": "Foto del tuo progetto del {date}",
  "gioCardPhotoFromDesignNoDate": "Foto di uno dei tuoi progetti",
  "gioCardPhotoFromChat": "Foto condivisa qui",
  "gioCardPhotoNew": "Nuova foto",
  "gioCardNoPhoto": "Ancora nessuna foto",
  "gioCardChangePhoto": "Cambia",
  "gioCardAddPhoto": "Aggiungi foto",
  "gioCardUploading": "Caricamento…",
  "gioCardSame": "Hai già un progetto {style} da questa foto ({date}).",
  "gioCardSameView": "Vedi",
  "gioCardSameHint": "Con la stessa richiesta il risultato sarà molto simile. Per cambiarlo, aggiungi una richiesta sopra, dillo a Gio in chat o aprilo in Crea.",
  "gioPickPhoto": "Scegli una foto",
  "gioPickUpload": "Carica una nuova foto",
  "gioRunEdit": "Modifica · {n} crediti",
  "gioRunGenerate": "Crea · {n} crediti",
  "gioRunWithPhoto": "Aggiungi foto e crea · {n}/foto",
  "gioOpenInCreate": "Apri in Crea",
  "gioPaintMyself": "Disegna l'area a mano",
  "gioStarting": "Avvio…",
  "gioJobMaking": "Creazione del tuo design…",
  "gioJobEditing": "Modifica del tuo design…",
  "gioJobNotify": "Puoi uscire — ti avviserò quando sarà pronto.",
  "gioJobInvalid": "Questa foto non sembra uno spazio che posso progettare.",
  "gioJobFailed": "Non sono riuscito a completare questo.",
  "gioJobRefunded": "I tuoi crediti sono stati rimborsati.",
  "gioJobDone": "Pronto — dai un'occhiata",
  "gioJobGone": "Questo design è stato eliminato.",
  "gioAskAboutDesign": "Chiedi a Gio di questo design",
  "navFeed": "Feed",
  "navMy": "I miei",
  "navAccount": "Impostazioni",
  "signIn": "Accedi",
  "signOut": "Esci",
  "deleteAccount": "Elimina account",
  "deleteAccountTitle": "Eliminare l'account?",
  "deleteAccountWarn": "Questo eliminerà definitivamente il tuo account e tutti i dati associati. L'azione non è revocabile.",
  "deleteAccountItem_designs": "Tutti i tuoi progetti, immagini e conversazioni con Gio",
  "deleteAccountItem_profile": "Il tuo profilo, handle e stili salvati",
  "deleteAccountItem_social": "Commenti, mi piace, seguiti e raccolte",
  "deleteAccountItem_credits": "Crediti rimanenti, inclusi quelli acquistati, e cronologia abbonamenti",
  "deleteAccountBilling_web": "Il tuo abbonamento web attivo verrà annullato automaticamente.",
  "deleteAccountBilling_ios": "L'abbonamento su App Store o Google Play non verrà annullato automaticamente — annullalo nelle impostazioni del tuo store.",
  "deleteAccountFinal": "Verrai disconnesso immediatamente e non potrai più recuperare questo account.",
  "deleteAccountConfirm": "Elimina account",
  "deleteAccountSubmitting": "Eliminazione in corso…",
  "deleteAccountError": "Impossibile eliminare l'account. Riprova.",
  "myDesigns": "I miei progetti",
  "language": "Lingua",
  "support": "Supporto",
  "terms": "Termini di servizio",
  "privacy": "Informativa sulla privacy",
  "signInTerms": "Accedendo, accetti i nostri {terms} e la {privacy}.",
  "onboardingSkip": "Salta",
  "onboardingNext": "Avanti",
  "onboardingStart": "Inizia",
  "tourTitle": "Tour di archelier",
  "tourCreate": "Inizia da qui. Scatta o carica una stanza, un esterno o un giardino, scegli uno stile e ricevi il nuovo progetto in pochi istanti.",
  "tourGallery": "Galleria — gli stili più scelti su archelier questa settimana. Toccane uno per provarlo nel tuo spazio.",
  "tourGio": "Gio è il tuo designer. Mostra una foto e dì cosa vuoi — Gio ti suggerisce gli stili, poi crea o modifica il progetto per te.",
  "tourMy": "I tuoi progetti si raccolgono in I miei. Ritocca anche solo una parte pennellandola o descrivendola, poi scarica o condividi.",
  "tourStart": "Torna su questo pulsante in qualsiasi momento per un nuovo progetto. Iniziamo con una foto.",
  "tourReplay": "Rivedi il tour",
  "onboarding": [
    {
      "icon": "photo_camera",
      "title": "Scatta, disegna o carica",
      "desc": "Una foto dal telefono è l'ideale, ma archelier legge anche schizzi a mano, prospetti, planimetrie dall'alto e screenshot di modelli 3D, tutto rilevato in automatico."
    },
    {
      "icon": "style",
      "title": "Oltre 19 stili, 4 modalità smart",
      "desc": "Scegli uno stile predefinito, scrivi un prompt personalizzato, usa una foto di riferimento o usa le modalità Cleanup / Layout per riordinare e riorganizzare lo spazio."
    },
    {
      "icon": "brush",
      "title": "Modifica solo la parte che desideri",
      "desc": "Non ti piace un angolo? Pennellalo sul risultato e di' all'IA cosa metterci. Il resto della stanza rimarrà identico al pixel."
    },
    {
      "icon": "auto_awesome",
      "title": "Provalo subito",
      "desc": "Ricevi crediti gratuiti ogni giorno. Carica una foto e il tuo primo progetto sarà pronto in circa un minuto."
    }
  ],
  "onboardTabFeedTitle": "Esplora prima",
  "onboardTabFeedDesc": "Guarda cosa hanno creato gli altri e trova l'ispirazione per il tuo spazio.",
  "onboardTabCreateTitle": "Progetta con l'IA",
  "onboardTabCreateDesc": "Carica una foto, uno schizzo o una planimetria: l'IA genererà un nuovo progetto.",
  "onboardTabMyTitle": "Salva e gestisci",
  "onboardTabMyDesc": "I tuoi progetti verranno salvati qui. Condividili nel feed o scaricali quando vuoi.",
  "onboardTabGioTitle": "Chiedi a Gio",
  "onboardTabGioDesc": "Gio, il nostro space designer, suggerisce stili dalle tue foto e può creare o modificare design direttamente in chat.",
  "myDesignsTitle": "I miei progetti",
  "signInToSee": "Accedi per vedere i tuoi progetti",
  "signInToSeeDesc": "I tuoi progetti salvati appariranno qui.",
  "loadingDesigns": "Caricamento progetti…",
  "errLoadDesigns": "Impossibile caricare i progetti. Riprova.",
  "retry": "Riprova",
  "noFavorites": "Ancora nessun preferito.",
  "noDesigns": "Ancora nessun progetto. Crea il tuo primo!",
  "createDesign": "Crea un progetto",
  "loadMore": "Carica altri",
  "loading": "Caricamento…",
  "errDesignNotFound": "Progetto non trovato.",
  "errLoadDesign": "Impossibile caricare il progetto.",
  "errDeleteDesign": "Impossibile eliminare. Riprova.",
  "renameTitle": "Rinomina progetto",
  "renamePlaceholders": [
    "Restyling soggiorno v1",
    "Cucina — versione luminosa",
    "Rinnovo studio",
    "Camera da letto, toni caldi",
    "Balcone piano B",
    "Configurazione home office",
    "Bozza interni bar",
    "Giardino anteriore v2"
  ],
  "save": "Salva",
  "cancel": "Annulla",
  "deleteTitle": "Eliminare il progetto?",
  "deleteDesc": "Questo eliminerà definitivamente il progetto e tutte le sue immagini. L'azione non è reversibile.",
  "delete": "Elimina",
  "deleting": "Eliminazione…",
  "postToFeed": "Pubblica nel feed",
  "postedToFeedTitle": "Pubblicato nel feed",
  "postedToFeedDesc": "Gli altri utenti ora possono vedere e mettere \"mi piace\" a questo progetto nel feed.",
  "captionTitle": "Aggiungi una didascalia",
  "captionPlaceholder": "Racconta perché hai riprogettato questo spazio (facoltativo)",
  "captionEdit": "Modifica didascalia",
  "captionPost": "Pubblica",
  "captionSave": "Salva",
  "captionCancel": "Annulla",
  "viewFeed": "Vedi il feed",
  "generationInProgress": "Progettazione dello spazio in corso…",
  "generationKeepBrowsing": "Continua pure a esplorare — ti avviseremo quando sarà pronto",
  "generationDone": "Il tuo progetto è pronto!",
  "generationTapToOpen": "Tocca Apri per vederlo",
  "generationFailedHint": "Il tuo credito non è stato scalato. Riprova.",
  "open": "Apri",
  "copy": "Copia",
  "copied": "Copiato!",
  "share": "Condividi",
  "downloadImages": "Scarica immagini IA",
  "download": "Scarica",
  "downloadWatermarkHint": "Una piccola firma di archelier apparirà nell'angolo in basso a destra.",
  "modes": {
    "redesign": "Restyling",
    "staging": "Allestimento stanza vuota"
  },
  "styleUsed": "Stile utilizzato",
  "customDescLabel": "Descrizione personalizzata:",
  "additionalReqLabel": "Richieste aggiuntive:",
  "useStyleAgain": "Usa di nuovo questo stile",
  "feedTitle": "Community",
  "feedEmpty": "Ancora nessun design pubblico. Inizia tu!",
  "feedSortLatest": "Più recenti",
  "feedSortPopular": "Popolari",
  "feedFilterAll": "Tutti",
  "useThisStyle": "Prova questo stile",
  "sourceDesignBanner": "Basato su \"{name}\"",
  "galleryPickBanner": "Creazione con {name}",
  "signInToLike": "Accedi per mettere mi piace",
  "tryApp": "Prova archelier",
  "privateTitle": "Questo design è privato",
  "privateDesc": "Il proprietario non ha reso pubblico questo design.",
  "linkNotFoundTitle": "Questo link non è disponibile",
  "linkNotFoundDesc": "Il design potrebbe essere stato eliminato o il link è incompleto.",
  "createWithApp": "Crea con archelier",
  "shareViewCTA": "Vuoi riprogettare il tuo spazio?",
  "styles": {
    "modern": {
      "name": "Moderno",
      "description": "Linee pulite, toni neutri, minimalismo contemporaneo"
    },
    "scandinavian": {
      "name": "Scandinavo",
      "description": "Luminoso, materiali naturali, accogliente calore nordico"
    },
    "ikea": {
      "name": "IKEA",
      "description": "Design scandinavo quotidiano, funzionale ed economico"
    },
    "japandi": {
      "name": "Japandi",
      "description": "Il minimalismo giapponese incontra il calore scandinavo"
    },
    "industrial": {
      "name": "Industriale",
      "description": "Materiali grezzi, elementi a vista, estetica da loft urbano"
    },
    "coastal": {
      "name": "Costiero",
      "description": "Eleganza fresca e luminosa da casa al mare"
    },
    "classic": {
      "name": "Classico",
      "description": "Eleganza senza tempo, tessuti pregiati, dettagli decorati"
    },
    "artdeco": {
      "name": "Art Deco",
      "description": "Geometrie audaci, dettagli dorati, opulenza glamour anni '20"
    },
    "midcentury": {
      "name": "Mid-Century Modern",
      "description": "Forme organiche, legno caldo, fascino rétro-moderno anni '50-'60"
    },
    "maximalist": {
      "name": "Massimalista",
      "description": "Fantasie audaci, strati ricchi, filosofia del \"più è meglio\""
    },
    "vintage": {
      "name": "Vintage",
      "description": "Fascino nostalgico, oggetti d'antiquariato, calda tavolozza rétro"
    },
    "bohemian": {
      "name": "Bohemian",
      "description": "Spirito libero, tessuti colorati, eclettismo artistico"
    },
    "tropical": {
      "name": "Tropicale",
      "description": "Verde lussureggiante, rattan, fresca atmosfera da resort"
    },
    "cottagecore": {
      "name": "Cottagecore",
      "description": "Romantica campagna inglese, motivi floreali, tonalità pastello"
    },
    "rustic": {
      "name": "Rustico",
      "description": "Legno invecchiato, pietra, caldo fascino rustico"
    },
    "wabisabi": {
      "name": "Wabi-Sabi",
      "description": "Bellezza imperfetta, texture grezze, pacato ascetismo giapponese"
    },
    "gothic": {
      "name": "Gotico",
      "description": "Atmosfere scure e drammatiche, velluto, silhouette decorate"
    },
    "cyberpunk": {
      "name": "Cyberpunk",
      "description": "Futurismo al neon, superfici hi-tech, distopia urbana"
    },
    "taisho_romance": {
      "name": "Taisho Romance",
      "description": "Il Giappone del primo '900 incontra l'Art Nouveau occidentale"
    },
    "biophilic": {
      "name": "Biofilico",
      "description": "Piante ovunque, luce naturale, texture organiche"
    },
    "cozy": {
      "name": "Accogliente",
      "description": "Caldo, morbido, invitante — comfort in stile hygge"
    },
    "gaming": {
      "name": "Gaming",
      "description": "Setup RGB, tecnologia elegante, postazione immersiva"
    },
    "minimalist": {
      "name": "Minimalista",
      "description": "Essenziale, senza disordine, spazio negativo"
    },
    "mediterranean": {
      "name": "Mediterraneo",
      "description": "Pareti a calce, terracotta, archi, pietra naturale"
    },
    "luxury": {
      "name": "Quiet Luxury",
      "description": "Materiali pregiati, tavolozza sobria, eleganza discreta"
    },
    "dark_academia": {
      "name": "Dark Academia",
      "description": "Biblioteca suggestiva — rosso scuro, ottone, libri impilati"
    },
    "organic_modern": {
      "name": "Moderno organico",
      "description": "Forme moderne in materiali naturali grezzi"
    },
    "farmhouse": {
      "name": "Farmhouse",
      "description": "Rivestimenti in legno, lavello a grembiule, legno vissuto, caldo country"
    },
    "halloween": {
      "name": "Halloween",
      "description": "Zucca, candele, atmosfere autunnali scure"
    },
    "christmas": {
      "name": "Natale",
      "description": "Albero, ghirlande, luci calde, decorazioni festive"
    },
    "lunar_new_year": {
      "name": "Capodanno lunare",
      "description": "Rosso e oro, lanterne, motivi di buon auspicio"
    },
    "spring_blossom": {
      "name": "Fioritura primaverile",
      "description": "Fiori di ciliegio, toni pastello, luce fresca e ariosa"
    },
    "custom": {
      "name": "Stile personalizzato",
      "description": "Descrivi la tua idea di interni unica"
    },
    "reference": {
      "name": "Riferimento",
      "description": "Riproduci i toni, i materiali e l'atmosfera di una foto caricata"
    },
    "floorplan": {
      "name": "Planimetria",
      "description": "Una planimetria 3D o un disegno pulito dalla tua planimetria"
    },
    "cleanup": {
      "name": "Riordino",
      "description": "Riordina il disordine o svuota la stanza — a te la scelta"
    },
    "layout": {
      "name": "Disposizione",
      "description": "Stessi mobili, disposizione più intelligente — fluida o spaziosa"
    }
  },
  "langMismatchNotice": "Questa analisi è stata generata in {lang}.",
  "pricingTitle": "Piani che crescono con te",
  "pricingSubtitle": "Inizia gratis. Passa a Pro quando hai bisogno di più generazioni e funzioni premium.",
  "pricePerMonth": "/ mese",
  "trialCta": "Inizia la prova gratuita di {n} giorni",
  "accountPlanFreeTitle": "Il tuo account è GRATUITO",
  "accountPlanProTitle": "Sei su Pro",
  "accountPlanTrialTitle": "Sei su Pro — Prova gratuita",
  "proTrialBadge": "Prova",
  "proTrialDaysLeft": "{n} giorni rimasti nella tua prova gratuita",
  "proTrialIntroTitle": "Ricevi 2 settimane di Pro gratis",
  "proTrialIntroDesc": "Registrati e inizia con {n} crediti gratuiti.",
  "proTrialFeatures": "Poi altri {n} gratis ogni giorno. Nessun abbonamento, mai.",
  "welcomeSkip": "Continua senza un account",
  "landingHeadline": "riprogetta qualsiasi stanza, in pochi secondi.",
  "landingTagline": "Scatta una foto, scegli uno stile, ottieni un rendering fotorealistico. Gratis ogni giorno, senza abbonamento.",
  "landingOpenWeb": "O continua sul web →",
  "landingFeat1": "Rendering d'interni IA",
  "landingFeat2": "Fotorealistico",
  "landingFeat3": "Oltre 50 stili",
  "landingFeat4": "Giardini ed esterni",
  "landingFeat5": "Gratis ogni giorno",
  "landingStoreOn": "Scarica su",
  "landingStoreGet": "Disponibile su",
  "lp": {
    "metaTitle": "archelier — AI Interior Design da foto, schizzo o planimetria",
    "metaDescription": "Scatta una foto di qualsiasi stanza e ottieni un restyling fotorealistico in circa un minuto. 48 stili per interni, esterni e giardini, planimetrie 3D, modifiche con pennello e un designer AI con cui chattare. Gratis ogni giorno.",
    "heroEyebrow": "AI interior design",
    "scrollCue": "Scopri come funziona",
    "webCta": "Provalo gratis nel browser",
    "orApp": "Oppure scarica l'app",
    "qrHint": "Inquadra con la fotocamera del telefono. L'app ti avvisa non appena il tuo progetto è pronto.",
    "showEyebrow": "Prima e dopo",
    "showTitle": "Una foto. Una stanza nuova.",
    "showBody": "Risultati reali, creati con archelier. Trascina per confrontare.",
    "before": "Prima",
    "after": "Dopo",
    "tabRoom": "Soggiorno",
    "tabEmpty": "Stanza vuota",
    "tabSketch": "Schizzo",
    "tabPlan": "Planimetria",
    "tabExterior": "Esterno",
    "capRoom": "Rustico — la stessa cucina e soggiorno, resi più accoglienti.",
    "capEmpty": "Scandinavo — una stanza vuota, arredata.",
    "capSketch": "Japandi — uno schizzo a linee, reso come uno spazio reale.",
    "capPlan": "Modalità planimetria — una pianta 2D trasformata in una vista 3D di tutta la casa.",
    "capExterior": "Minimalista — una vetrina caotica, riprogettata.",
    "howEyebrow": "Come funziona",
    "howTitle": "Tre passaggi, circa un minuto.",
    "how1Title": "Scatta una foto",
    "how1Body": "Qualsiasi stanza, così com'è — oppure uno schizzo, una planimetria o uno screenshot 3D. Fino a 3 angolazioni della stessa stanza.",
    "how2Title": "Scegli uno stile",
    "how2Body": "Scegli tra 48 stili, descrivi il tuo in una frase o carica una foto che ti piace.",
    "how3Title": "Ottieni il tuo design",
    "how3Body": "Un rendering fotorealistico del tuo spazio, con lista arredi, palette di colori e piano luci.",
    "stylesEyebrow": "Stili",
    "stylesTitle": "48 stili, tre tipi di spazi.",
    "stylesBody": "28 per interni, 11 per esterni, 9 per giardini — oltre a look stagionali per Halloween, Natale, Capodanno cinese e primavera.",
    "stylesInterior": "Interni",
    "stylesExterior": "Esterni",
    "stylesGarden": "Giardino",
    "stylesCta": "Esplora la galleria degli stili",
    "modesEyebrow": "Oltre gli stili",
    "modesTitle": "Altri cinque modi per progettare uno spazio.",
    "modeCustomTitle": "Stile personalizzato",
    "modeCustomBody": "Descrivi lo stile in una frase e salvalo per la prossima volta.",
    "modeReferenceTitle": "Riferimento",
    "modeReferenceBody": "Carica una foto che ami e riprendine toni, materiali e palette — senza cambiarne la disposizione.",
    "modeCleanupTitle": "Sgombero",
    "modeCleanupBody": "Rimuovi il disordine e vedi la stanza vuota.",
    "modeLayoutTitle": "Layout",
    "modeLayoutBody": "Riorganizza i mobili già presenti invece di sostituirli.",
    "modePlanTitle": "Planimetria",
    "modePlanBody": "Trasforma una planimetria in una vista 3D dell'intera casa o una bozza in un disegno pulito.",
    "editEyebrow": "Modifica con pennello",
    "editTitle": "Modifica un elemento alla volta.",
    "editBody": "Non ti piace solo il divano? Cerchialo e scrivi cosa vorresti al suo posto. archelier ridisegna solo quell'area lasciando intatto il resto della stanza — vale anche per il colore delle pareti, tappeti, illuminazione e quadri.",
    "editPrompt": "Un divano in pelle vintage",
    "shopTitle": "Acquista ciò che vedi.",
    "shopBody": "Ogni progetto include una lista di arredi, una palette di colori e un piano luci, e ogni pezzo rimanda alla ricerca di prodotti simili.",
    "gioEyebrow": "Gio",
    "gioTitle": "Parla con un designer.",
    "gioBody": "Gio è il tuo designer AI, in una scheda dedicata. Invia una foto della tua stanza, un'immagine o un link di uno spazio che ti piace, o un tuo progetto. Gio ti suggerisce una direzione e crea o modifica il progetto per te, direttamente in chat.",
    "gioRole": "Designer di spazi",
    "gioUser": "Questa è la mia cucina con zona pranzo. Sembra un po' fredda. Qualche idea?",
    "gioReply": "Aggiungiamo legno caldo, tessuti morbidi e una luce soffusa invece di superfici fredde. Ecco un'idea da provare:",
    "gioCardTitle": "Calore Japandi",
    "gioCardBody": "Rovere naturale e intonaco materico donano subito calore allo spazio.",
    "gioCardAction": "Crea",
    "priceEyebrow": "Prezzi",
    "priceTitle": "Gratis ogni giorno. Senza abbonamento.",
    "price1": "Progetti gratuiti ogni giorno, aggiornati alla tua mezzanotte",
    "price2": "Un bonus quando crei un account",
    "price3": "Invita un amico per averne di più entrambi",
    "price4": "Te ne servono altri? Ricarica con un pacchetto crediti",
    "privacyTitle": "Le tue foto restano tue.",
    "privacyBody": "Le tue foto, i tuoi prompt e i tuoi progetti non vengono mai usati per addestrare modelli AI o per la pubblicità. I tuoi progetti restano privati a meno che non li condivida tu.",
    "faqTitle": "Domande",
    "faq1Q": "Cos'è archelier?",
    "faq1A": "archelier (Architect + Atelier) è un'app di interior design AI per smartphone e web. Inquadra la stanza, scegli uno stile e ottieni un restyling fotorealistico di quello spazio, con ogni mobile identificato e linkato. Funziona per interni, esterni e giardini.",
    "faq2Q": "Come funziona?",
    "faq2A": "Scatta una foto della stanza o carica uno schizzo, una planimetria o uno screenshot 3D. Scegli tra 48 stili, descrivi il tuo o carica una foto di riferimento. In circa un minuto otterrai un rendering fotorealistico dello spazio, insieme a lista arredi, palette di colori e piano luci.",
    "faq3Q": "archelier è gratis?",
    "faq3A": "Sì. Non c'è alcun abbonamento. Tutti ricevono progetti gratuiti ogni giorno, aggiornati alla mezzanotte locale, oltre a un bonus quando crei un account e quando inviti un amico. Se ne vuoi di più, puoi acquistare un pacchetto crediti.",
    "faq4Q": "Può trasformare una planimetria in un rendering 3D?",
    "faq4A": "Sì. La modalità Planimetria trasforma una pianta 2D in una vista 3D dell'intera casa nello stile prescelto. Può anche trasformare uno schizzo a mano o una pianta sfuocata in un disegno chiaro o a colori.",
    "faq5Q": "Posso riprodurre lo stile di una foto che mi piace?",
    "faq5A": "Sì. Scegli lo stile Riferimento e carica la foto di ispirazione. archelier ne riprende toni, materiali e palette applicandoli alla tua stanza senza copiarne la disposizione.",
    "faq6Q": "Posso modificare anche solo una parte del progetto?",
    "faq6A": "Sì. Cerchia l'area che vuoi modificare (il divano, il tappeto, una parete) e scrivi cosa desideri al suo posto. Solo quell'area verrà modificata; il resto della stanza rimarrà invariato.",
    "faq7Q": "Cos'è Gio?",
    "faq7A": "Gio è il designer d'interni AI di archelier. Inviagli la foto di una stanza, l'immagine o il link di uno spazio che ami o uno dei tuoi progetti. Gio ti suggerisce una direzione, crea o modifica il progetto in chat e risponde alle tue domande su colori, budget e illuminazione.",
    "faq8Q": "Le mie foto vengono usate per addestrare l'IA?",
    "faq8A": "No. archelier non usa le tue foto, i tuoi prompt o i tuoi progetti per addestrare modelli AI o per fini pubblicitari. I tuoi progetti restano privati sul tuo account finché non li condividi.",
    "faq9Q": "Dove posso usare archelier?",
    "faq9A": "Sull'App Store, su Google Play e sul web all'indirizzo archelier.co. Il tuo account e i tuoi progetti restano sincronizzati ovunque. archelier è disponibile in 11 lingue.",
    "ctaTitle": "Rinnova la tua stanza oggi.",
    "ctaBody": "Sul tuo smartphone e sul web. I tuoi progetti restano sincronizzati ovunque.",
    "langLabel": "Lingua"
  },
  "upgradeToPro": "Passa a Pro",
  "creditsPerMonth": "{n} crediti al mese",
  "planFreeName": "Gratuito",
  "planFreeTagline": "Prova archelier con alcuni progetti ogni mese.",
  "planProName": "Pro",
  "planProTagline": "Per designer abituali che desiderano risultati di qualità.",
  "planStudioName": "Studio",
  "planStudioTagline": "Per utenti esperti, team e uso commerciale.",
  "planFeatWatermark": "Include filigrana \"archelier\"",
  "planFeatNoWatermark": "Nessuna filigrana sui progetti salvati o condivisi",
  "planFeatUnlimited": "Generazioni di design IA illimitate",
  "planFeatUnlimitedChat": "Chat IA illimitata per progetto (gratis: 3 scambi)",
  "planFeatUnlimitedEdit": "Modifiche dell'area illimitate",
  "planFeatFeed": "Condividi nel feed",
  "planFeatEverythingPro": "Tutto incluso in Pro",
  "planFeatCommercial": "Diritti di utilizzo commerciale",
  "planFeatApiAccess": "Accesso API (prossimamente)",
  "planCtaSubscribe": "Abbonati",
  "planCtaCurrent": "Il tuo piano attuale",
  "planPopular": "Più popolare",
  "signInToSubscribe": "Accedi per abbonarti",
  "signInToBuy": "Accedi per acquistare",
  "trialNote": "Prova gratuita di {n} giorni",
  "creditPacksTitle": "O ricarica con i pacchetti di crediti",
  "creditPacksSubtitle": "Acquisto singolo, nessun abbonamento richiesto.",
  "packStarterName": "Starter Pack",
  "packStandardName": "Standard Pack",
  "packProName": "Pro Pack",
  "packCreditsAmount": "{n} crediti",
  "packCtaBuy": "Acquista",
  "pricingFootnote": "Prezzi in USD. Tasse calcolate al pagamento. Disdici quando vuoi.",
  "errBillingGeneric": "Si è verificato un errore durante l'operazione. Riprova.",
  "accountTitle": "Impostazioni",
  "accountPlanSection": "Abbonamento",
  "accountCreditsSection": "Crediti",
  "accountCreditsDesc": "I crediti vengono consumati quando generi dei design. Ricarica quando vuoi.",
  "viewPlans": "Vedi i piani",
  "changePlan": "Cambia piano",
  "manageBilling": "Gestisci fatturazione",
  "manageBillingWebHint": "Se ti sei abbonato sul web, puoi gestirlo su archelier.co.",
  "buyCreditPack": "Acquista pacchetto crediti",
  "subRenewsAt": "Si rinnova il {date}",
  "subEndsAt": "Termina il {date}",
  "trialEndsAt": "La prova gratuita termina il {date} — si rinnova a $9.99/mese",
  "trialCancelEndsAt": "La prova termina il {date} — l'abbonamento non si rinnoverà",
  "subStatus_past_due": "Pagamento scaduto — aggiorna il tuo metodo di pagamento.",
  "subStatus_canceled": "Abbonamento annullato.",
  "subStatus_unpaid": "Abbonamento non pagato.",
  "subStatus_trialing": "Prova gratuita attiva.",
  "account": "Account",
  "pricing": "Prezzi",
  "upgrade": "Aggiorna",
  "inviteTitle": "Invita amici e guadagna crediti",
  "inviteSubtitle": "Quando un amico si iscrive con il tuo link, ricevi +{inviter} crediti e lui riceve +{invitee}.",
  "inviteFriends": "Invita amici",
  "inviteSignInHint": "Accedi per ricevere il tuo link d'invito personale.",
  "yourReferralCode": "Il tuo link d'invito",
  "inviteCodeLoading": "Preparazione del link d'invito in corso…",
  "inviteLinkHint": "I nuovi iscritti tramite il tuo link ricevono +{n} crediti di partenza.",
  "copyLink": "Copia link",
  "shareLink": "Condividi link",
  "inviteShareText": "Riprogetta i tuoi spazi con l'IA su archelier. Usa il mio link per ricevere +{n} crediti gratis.",
  "redeemTitle": "Hai un codice?",
  "redeemDesc": "Inserisci un codice invito di un amico o un codice promozionale per ricevere crediti bonus.",
  "copyCode": "Copia codice",
  "errRefSelf": "Non puoi usare il tuo stesso codice invito.",
  "landingInviteTitle": "Un amico ti ha invitato: riceverete entrambi +{n} crediti.",
  "landingInviteAutoIos": "Installa l'app, poi tocca di nuovo questo link d'invito — l'app si apre e il tuo bonus viene aggiunto quando ti registri.",
  "landingInviteAutoAndroid": "Installa con il pulsante Google Play qui sotto e registrati — il tuo bonus viene aggiunto automaticamente. Se non succede, inserisci questo codice in Impostazioni → Invita amici.",
  "landingInviteDesktop": "Registrati qui e il tuo bonus viene aggiunto subito. Per averlo nell'app, scansiona il codice QR e segui le istruzioni sul telefono.",
  "promoTitle": "Hai un codice promo?",
  "promoDesc": "Inserisci un codice promo per riscattare crediti bonus.",
  "promoPlaceholder": "es. LAUNCH2026",
  "promoRedeem": "Riscatta",
  "promoSuccess": "Riscattato — {n} crediti aggiunti al tuo account.",
  "errPromoInvalid": "Codice non valido.",
  "errPromoExpired": "Questo codice è scaduto.",
  "errPromoMaxed": "Questo codice ha raggiunto il limite di utilizzi.",
  "errPromoUsed": "Hai già riscattato questo codice.",
  "errPromoUserInit": "Ricarica e riprova.",
  "errPromoGeneric": "Impossibile riscattare il codice. Riprova.",
  "reportThisDesign": "Segnala questo design",
  "reportShort": "Segnala",
  "reportTitle": "Segnala design",
  "reportDesc": "Cosa non va in questo design? Solo i moderatori vedranno la segnalazione.",
  "reportReason_spam": "Spam o pubblicità",
  "reportReason_nsfw": "Contenuto sessuale o inappropriato",
  "reportReason_copyright": "Violazione del copyright",
  "reportReason_other": "Altro",
  "reportNotePlaceholder": "Aggiungi dettagli (opzionale, max 500 caratteri)",
  "reportSubmit": "Invia segnalazione",
  "reportSubmitting": "Invio in corso…",
  "reportSignInHint": "Accedi per inviare una segnalazione.",
  "reportThanks": "Segnalazione ricevuta",
  "reportThanksDesc": "Controlleremo e interverremo se necessario. Grazie per la segnalazione.",
  "errReportGeneric": "Impossibile inviare la segnalazione. Riprova tra un momento.",
  "blockUser": "Blocca questo utente",
  "unblockUser": "Sblocca",
  "blockShort": "Blocca",
  "blockConfirm": "Vuoi bloccare @{handle}? Non vedrai i suoi design o attività, e non potrà interagire con i tuoi.",
  "blockedUsersMenu": "Utenti bloccati",
  "blockedUsersTitle": "Utenti bloccati",
  "blockedUsersDesc": "Utenti che hai bloccato. I loro design sono nascosti dal tuo feed e dai profili.",
  "blockedUsersEmpty": "Non hai bloccato nessuno.",
  "profileBlocked": "Hai bloccato questo utente.",
  "profileBlockedAction": "Sblocca per vedere di nuovo i suoi design.",
  "errBlockGeneric": "Impossibile aggiornare lo stato del blocco. Riprova.",
  "errBlockedCustomCommand": "La tua richiesta contiene parole non consentite.",
  "moderationAutoUnlisted": "Questo design è stato rimosso automaticamente dal feed pubblico per moderazione. Se ritieni sia un errore, contatta gli amministratori.",
  "promptLang": "Italian"
};
